<ng-template elderToolbarColumn="right.actions">
  <app-facility-context-menu></app-facility-context-menu>
</ng-template>

<elder-basic-pane-layout class="full" appFacilityContext (facilityChange)="facility = $event">
  <elder-pane>
    <app-work-center-browser class="flex" [facility]="(facility$ | async)?.id" [canAdd]="true">
    </app-work-center-browser>
  </elder-pane>
</elder-basic-pane-layout>
